export default "__VITE_ASSET__241ca389__"